import router from "@/router";
import {Product} from "@/data/classes/product";
let product = new Product();

export const tabs : any[] = [
    {
        key: "general",
        label: "product-form.tabs.general",
        type: "single",
        sections: [
            {
                inputs: [
                    {
                        label: 'product-form.sku',
                        name: 'input_product_sku',
                        type: 'text',
                        required: true,
                        path: "Sku",
                        decode: (value: string) => {
                            return value ? value.replace(" ", "_") : "";
                        },
                        size: 100
                    },
                ]
            },
            {
                title: 'product-form.sections.main',
                inputs: [
                    {
                        label: 'product-form.nickname',
                        name: 'input_product_nickname',
                        type: 'text',
                        required: true,
                        path: "Nickname",
                        size: 100
                    },
                    {
                        label: 'product-form.translate-from',
                        name: 'input_product_translate_from',
                        type: 'select',
                        options: [{
                            key: "none",
                            label: "product-form.do-not-translate",
                            value: "none"
                        },{
                            key: "nl",
                            label: "product-form.translate-from-dutch",
                            value: "NL"
                        }],
                        required: true,
                        rules: '',
                        path: "TranslateFrom",
                        size: 100
                    },
                    {
                        label: 'product-form.title',
                        name: 'input_product_title',
                        type: 'multilingual_text',
                        required: true,
                        path: "Title",
                        size: 100,
                        condition: (item: Product) : boolean => {
                            return item?.TranslateFrom === "none";
                        }
                    },
                    {
                        label: 'product-form.title',
                        name: 'input_product_title_nl',
                        type: 'text',
                        required: true,
                        path: "Title.NL",
                        size: 100,
                        condition: (item: Product) : boolean => {
                            return item?.TranslateFrom !== "none";
                        }
                    },
                    {
                        label: 'product-form.title-short',
                        name: 'input_product_title_short',
                        type: 'multilingual_text',
                        required: false,
                        rules: '',
                        path: "TitleShort",
                        size: 50,
                        condition: (item: Product) : boolean => {
                            return item?.TranslateFrom === "none";
                        }
                    },
                    {
                        label: 'product-form.title-short',
                        name: 'input_product_title_short_nl',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "TitleShort.NL",
                        size: 50,
                        condition: (item: Product) : boolean => {
                            return item?.TranslateFrom !== "none";
                        }
                    },
                    {
                        label: 'product-form.ribbon-text',
                        name: 'input_product_ribbon_text',
                        type: 'multilingual_text',
                        required: false,
                        rules: '',
                        path: "RibbonText",
                        size: 50,
                        condition: (item: Product) : boolean => {
                            return item?.TranslateFrom === "none";
                        }
                    },
                    {
                        label: 'product-form.ribbon-text',
                        name: 'input_product_ribbon_text_nl',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "RibbonText.NL",
                        size: 50,
                        condition: (item: Product) : boolean => {
                            return item?.TranslateFrom !== "none";
                        }
                    },
                    {
                        label: 'product-form.description',
                        name: 'input_product_description',
                        type: 'multilingual_textarea',
                        required: false,
                        rules: '',
                        path: "Description",
                        size: 100,
                        condition: (item: Product) : boolean => {
                            return item?.TranslateFrom === "none";
                        }
                    },
                    {
                        label: 'product-form.description',
                        name: 'input_product_description_nl',
                        type: 'textarea',
                        required: false,
                        rules: '',
                        path: "Description.NL",
                        size: 100,
                        condition: (item: Product) : boolean => {
                            return item?.TranslateFrom !== "none";
                        }
                    }
                ]
            },
            {
                title: 'product-form.sections.bullet-points',
                inputs: [
                    {
                        label: 'product-form.bullet-points',
                        name: 'input_product_bullet_points',
                        type: 'multilingual_list',
                        required: false,
                        path: "BulletPoints",
                        size: 100,
                        condition: (item: Product) : boolean => {
                            return item?.TranslateFrom === "none";
                        }
                    },
                    {
                        label: 'product-form.bullet-points',
                        name: 'input_product_bullet_points_nl',
                        type: 'list',
                        required: false,
                        path: "BulletPoints",
                        decode: (items: any[]) => {
                            return items ? items.map((item) => item.NL) : [];
                        },
                        encode: (items: any[]) => {
                            return items ? items.map((item) => {
                                return {
                                    NL: item
                                }
                            }) : [];
                        },
                        size: 100,
                        condition: (item: Product) : boolean => {
                            return item?.TranslateFrom !== "none";
                        }
                    },
                ]
            }
        ]
    },
    {
        key: "price",
        label: "product-form.tabs.pricing",
        type: "single",
        sections: [
            {
                title: 'product-form.sections.pricing',
                inputs: [
                    {
                        label: 'product-form.price-type',
                        name: 'input_product_price_type_one_time',
                        type: 'select',
                        options: [{
                            key: "one_time",
                            label: "product-form.one-time",
                            value: "one_time"
                        },{
                            key: "recurring",
                            label: "product-form.recurring",
                            value: "recurring"
                        }],
                        required: true,
                        path: "Price.Type",
                        size: 50,
                        bindings: [{
                            path: "Info.AllowLimitExceed",
                            force: true,
                            processor: (x: string) => {
                                return x === "one_time" ? false : true;
                            }
                        }],
                        condition: (item: Product) : boolean => {
                            return item?.Price?.Type === "one_time";
                        }
                    },
                    {
                        label: 'product-form.expiration-term',
                        name: 'input_product_expiration_term',
                        type: 'select',
                        options: [{
                            key: "month",
                            label: "product-form.month",
                            value: "month"
                        },{
                            key: "year",
                            label: "product-form.year",
                            value: "year"
                        }],
                        required: true,
                        path: "Info.ExpirationTerm",
                        size: 50,
                        condition: (item: Product) : boolean => {
                            return item?.Price?.Type === "one_time";
                        }
                    },
                    {
                        label: 'product-form.scans',
                        name: 'input_product_scans',
                        type: 'number',
                        required: true,
                        path: "Info.ScanAmount",
                        size: 50,
                        bindings: [{
                            path: "Price.BaseTier.UpTo",
                            force: true,
                            processor: (x: number) => {
                                return x;
                            }
                        }],
                        condition: (item: Product) : boolean => {
                            return item?.Price?.Type === "one_time";
                        }
                    },
                    {
                        label: 'product-form.price-amount',
                        name: 'input_product_price_amount',
                        type: 'number',
                        required: true,
                        path: "Price.Amount",
                        size: 50,
                        bindings: [{
                            path: "Price.BaseTier.FlatAmount",
                            force: true,
                            processor: (x: number) => {
                                return x;
                            }
                        }],
                        condition: (item: Product) : boolean => {
                            return item?.Price?.Type === "one_time";
                        }
                    },
                    {
                        label: 'product-form.price-type',
                        name: 'input_product_price_type',
                        type: 'select',
                        options: [{
                            key: "one_time",
                            label: "product-form.one-time",
                            value: "one_time"
                        },{
                            key: "recurring",
                            label: "product-form.recurring",
                            value: "recurring"
                        }],
                        required: true,
                        path: "Price.Type",
                        size: 50,
                        bindings: [{
                            path: "Info.AllowLimitExceed",
                            force: true,
                            processor: (x: string) => {
                                return x === "one-time" ? false : true;
                            }
                        }],
                        condition: (item: Product) : boolean => {
                            return item?.Price?.Type === "recurring";
                        }
                    },
                    {
                        label: 'product-form.interval',
                        name: 'input_product_interval',
                        type: 'select',
                        options: [{
                            key: "month",
                            label: "product-form.month",
                            value: "month"
                        },{
                            key: "year",
                            label: "product-form.year",
                            value: "year"
                        }],
                        required: true,
                        path: "Price.Interval",
                        size: 50,
                    },
                    {
                        label: 'product-form.base-tier.scans',
                        name: 'input_product_base_tier_quantity',
                        type: 'number',
                        required: true,
                        path: "Price.BaseTier.UpTo",
                        size: 50,
                        bindings: [{
                            path: "Info.ScanAmount",
                            force: true,
                            processor: (x: number) => {
                                return x;
                            }
                        }],
                        condition: (item: Product) : boolean => {
                            return item?.Price?.Type === "recurring";
                        }
                    },
                    {
                        label: 'product-form.base-tier.flat-amount',
                        name: 'input_product_base_tier_flat_amount',
                        type: 'number',
                        required: true,
                        path: "Price.BaseTier.FlatAmount",
                        size: 50,
                        bindings: [{
                            path: "Price.Amount",
                            force: true,
                            processor: (x: number) => {
                                return x;
                            }
                        },{
                            path: "Price.ExtraTier.FlatAmount",
                            force: true,
                            processor: (x: number) => {
                                return x;
                            }
                        }],
                        condition: (item: Product) : boolean => {
                            return item?.Price?.Type === "recurring";
                        }
                    },
                    // {
                    //     label: 'product-form.base-tier.unit-amount',
                    //     name: 'input_product_base_tier_unit_amount',
                    //     type: 'number',
                    //     required: true,
                    //     path: "Price.BaseTier.UnitAmount",
                    //     size: 35,
                    //     condition: (item: Product) : boolean => {
                    //         return item?.Price?.Type === "recurring";
                    //     }
                    // },
                    // {
                    //     label: 'product-form.extra-tier.scans',
                    //     name: 'input_product_extra_tier_quantity',
                    //     type: 'number',
                    //     required: true,
                    //     path: "Price.BaseTier.UpTo",
                    //     disabled: true,
                    //     size: 30,
                    //     condition: (item: Product) : boolean => {
                    //         return item?.Price?.Type === "recurring";
                    //     }
                    // },
                    // {
                    //     label: 'product-form.extra-tier.flat-amount',
                    //     name: 'input_product_extra_tier_flat_amount',
                    //     type: 'number',
                    //     required: true,
                    //     path: "Price.ExtraTier.FlatAmount",
                    //     disabled: true,
                    //     size: 35,
                    //     condition: (item: Product) : boolean => {
                    //         return item?.Price?.Type === "recurring";
                    //     }
                    // },

                    {
                        label: 'product-form.allow-limit-exceed',
                        name: 'input_product_allow_limit_exceed',
                        type: 'checkbox',
                        required: false,
                        path: "Info.AllowLimitExceed",
                        size: 50,
                        condition: (item: Product) : boolean => {
                            return item?.Price?.Type === "recurring";
                        }
                    },
                    {
                        label: 'product-form.extra-tier.unit-amount',
                        name: 'input_product_extra_tier_unit_amount',
                        type: 'number',
                        required: true,
                        path: "Price.ExtraTier.UnitAmount",
                        size: 50,
                        condition: (item: Product) : boolean => {
                            return item?.Price?.Type === "recurring" && item?.Info?.AllowLimitExceed;
                        }
                    },
                    // {
                    //     label: 'product-form.tax-included',
                    //     name: 'input_product_price_tax_included',
                    //     type: 'checkbox',
                    //     required: false,
                    //     path: "Price.TaxIncluded",
                    //     size: 100
                    // },
                ]
            }
        ]
    }
]


export const getData = async () => {
    if (router.currentRoute.params.productId !== "new"){
        await product.get(router.currentRoute.params.productId);
    } else {
        product = new Product()
    }

    return product.toJSON();
}


export const onSubmit = async (formValues: any) => {
    // Set values
    product.set(formValues);

    // Update product
    return product.update();
}
